<template>
  <div id="app" class="footer-remove">
<!--    <AppHeader></AppHeader>-->
    <div class="wrapper">
        <router-view></router-view>
    </div>
    <AppFooter></AppFooter>
  </div>

</template>

<script>
// import AppHeader from './Header.vue'
import AppFooter from './Footer.vue'
import 'bootstrap/scss/bootstrap.scss'
import 'fullcalendar/dist/fullcalendar.min.css'
export default {
  name: 'AppLayout',
  components: {
    // AppHeader,
    AppFooter
  },
  created () {
    // this.$router.push('/')
  }
}
</script>s
